import {Component, forwardRef, Inject, OnDestroy, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {LoginService} from "./login.service";
import {logErrors} from "../misc/log-errors.decorator";

@Component({
  templateUrl: "./session-timeout-dialog.template.pug",
})
export class SessionTimeoutDialogComponent extends DialogComponent<any, void> implements OnInit, OnDestroy {
  showLoginPopupSuccessful: boolean = true;
  tryAgainInterval: any;

  constructor(
    public dialogService: DialogService,
    @Inject(forwardRef(() => LoginService)) public loginService: LoginService,
  ) {
    super(dialogService);
  }

  private tryAgain() {
    if (this.loginService.sessionTimeRemaining > 0) return;
    this.loginService.init();
  }

  private startTryingAgain() {
    this.stopTryingAgain();

    this.tryAgainInterval = setInterval(() => this.tryAgain(), 1000 * 60 * 10);
    this.tryAgain();
  }

  private stopTryingAgain() {
    if (!this.tryAgainInterval) return;
    clearInterval(this.tryAgainInterval);
    this.tryAgainInterval = 0;
  }

  ngOnInit(): void {
    this.startTryingAgain();
  }

  ngOnDestroy(): void {
    this.stopTryingAgain();
    super.ngOnDestroy();
  }

  ready() {
    const hideSubscription = this.loginService.dialog.subscribe((value) => {
      if (value !== "show") {
        hideSubscription.unsubscribe();
        super.close();
      }
    });
  }

  @logErrors()
  async tryRenewing() {
    let success = false;
    try {
      success = await this.loginService.renew();
    } catch {
      success = false;
    }

    if (success) {
      this.close();
    } else {
      await this.tryLoggingIn();
    }
  }

  @logErrors()
  async tryLoggingIn() {
    this.stopTryingAgain();
    this.showLoginPopupSuccessful = true;
    this.showLoginPopupSuccessful = await this.loginService.logIn();

    this.startTryingAgain();

    await new Promise((resolve) => {
      setTimeout(() => resolve(), 2000);
    });

    this.close();
  }

  close() {
    this.loginService.hideDialogs();
  }
}
